import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import { CommonCompanyList } from './Common/CommonCompanyList';

const CompanyPage = () => {
	return (
		<PageWrapper title='Empresas'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonCompanyList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default CompanyPage;
